<template>
    <div v-if="skuInfo && has_show">
        <div v-if="orientation === 'horizontal'">
            <Wp_card_sku style="margin-left: 10px; margin-right: 10px" @click="buyGoods">

                <div id="img_div" slot="left">
                    <Wp_image :url="skuInfo.imageInfo.imageList[0].url" :img-gray="imgGray"></Wp_image>
                </div>
                <div slot="right" style="margin-left: 10px;">
                    <div class="sku_title">
                        <h3>
                            <span>
                                <van-tag type="danger" style="font-size: 12px; padding: 0px 6px"
                                         v-if="skuInfo.owner==='g'">京东自营</van-tag>
                                <van-tag type="danger" style="font-size: 12px; padding: 0px 6px" v-else>京东</van-tag>
                            </span>
                            {{skuInfo.skuName}}
                        </h3>
                    </div>

                    <!--                商品标签一行-->
                    <div class="sku_tags">

                        <div style="float:left;margin: 2px"
                             v-if="couponData && couponData.discount && skuInfo.priceInfo.lowestCouponPrice">
                            <JdCouponBar :couponData="couponData"></JdCouponBar>
                        </div>

                        <span v-if="skuInfo.pinGouInfo.pingouPrice" style="float:left;color:red;margin: 2px 5px; ">
                                <Icon type="ios-contacts" size="20"/>
                                {{skuInfo.pinGouInfo.pingouTmCount}}人拼
                    </span>

                        <div style="float:left;margin: 2px" v-if="skuInfo.isHot===1">
                            <van-tag color="red" plain>爆品</van-tag>
                        </div>
                    </div>

                    <!--                佣金相关一行-->
                    <div v-if="(!$common.gloabl_wx_openid || $common.gloabl_wx_mini_login_status === 'super') && $common.getPid()"
                         style="color:red" class="sku_price">
                        <Row>
                            <i-col span="12">
                                <!--                            佣金:{{skuInfo.commissionInfo.commission}}-->
                                预估佣金:￥{{commission}}
                            </i-col>
                            <i-col span="12">
                                <!--                            佣金比例:{{skuInfo.commissionInfo.commissionShare}}%-->
                                佣金比例:{{commissionShare}}%
                            </i-col>
                        </Row>
                    </div>
                    <!--                价格一行-->
                    <div class="sku_price">
                        <div v-if="couponData && couponData.discount && skuInfo.priceInfo.lowestCouponPrice">
                            <div style="float:left;color:red">内购价:¥
                                <span class="result_price">{{(skuInfo.priceInfo.lowestCouponPrice).toFixed(2)}}</span>
                            </div>
                            <div class="sku_old_price" style="float:left;margin-left: 10px; margin-top: 2px">
                                <span style="font-size:10px;color:gray;text-decoration:line-through;">¥{{skuInfo.priceInfo.lowestPrice}}</span>
                            </div>
                        </div>
                        <div v-else>
                            <div style="float:left;color:red">
                            <span>
                                京东价:¥<span class="result_price">{{skuInfo.priceInfo.lowestPrice}}</span>
                            </span>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <div v-if="$common.gloabl_wx_openid && $config.project !== 'hm'"
                         style="text-align: right; margin-top: 10px">
                        <van-button class="sku_card_bottom_btn"
                                    type="danger"
                                    size="small"
                                    icon="shopping-cart-o"
                                    v-on:click.stop="buyGoods"
                        >立即购买
                        </van-button>
                    </div>
                </div>

                <div slot="bottom">
                    <div style="text-align: right; margin-top: 5px; margin-bottom: 10px">

                        <!--                    <span v-if="$common.gloabl_wx_openid && $config.project !== 'hm'"-->
                        <!--                          style="margin-right: 5px; padding: 3px 20px 3px 15px; color: #c5940a; border-radius: 10px; border: 1px solid #c5940a99"-->
                        <!--                          @click="clickToUpgrade">-->
                        <!--                        升级超级会员推广可赚￥{{commission}}&nbsp;-->
                        <!--                        <van-icon name="arrow" style="position: absolute; margin-top: 3px" />-->
                        <!--                    </span>-->

                        <span v-if="(!$common.gloabl_wx_openid || $common.gloabl_wx_mini_login_status === 'super') && $common.getPid()">
                        <van-button class="sku_card_bottom_btn"
                                    plain
                                    type="danger"
                                    size="small"
                                    icon="share"
                                    v-on:click="makeLinks"

                        >立即推广
                        </van-button>


                        <van-button class="sku_card_bottom_btn"
                                    plain
                                    type="info"
                                    size="small"
                                    icon="add-o"
                                    v-on:click="addInSelectList"
                        >加入清单
                        </van-button>

                            <!--                    制作海报-->
                        <van-button class="sku_card_bottom_btn"
                                    plain
                                    type="primary"
                                    size="small"
                                    icon="photo-o"
                                    @click="showSharePop"
                        >制作海报
                        </van-button>
                        <Wp_share_poster :share-url="newLink"
                                         :activeShow="show_share_pop"
                        >
                            <div style="text-align: center">
                                <Wp_image :url="share_img_url" width="100%"/>
                            </div>
                            <div slot="text">
                                <div><span style="font-size: 12px">{{skuInfo.skuName}}</span></div>
                                <div v-if="couponData && couponData.discount && skuInfo.priceInfo.lowestCouponPrice">
                                    <div style="float:left;color:red">内购价:¥
                                        <span class="result_price">{{(skuInfo.priceInfo.lowestCouponPrice).toFixed(2)}}</span>
                                    </div>
                                    <div class="sku_old_price" style="float:left;margin-left: 10px; margin-top: 2px">
                                        <span style="font-size:10px;color:gray;text-decoration:line-through;">¥{{skuInfo.priceInfo.lowestPrice}}</span>
                                    </div>
                                </div>
                                <div v-else>
                                    <div style="float:left;color:red">
                                        <span>
                                            京东价:¥<span class="result_price">{{skuInfo.priceInfo.lowestPrice}}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Wp_share_poster>
                    </span>
                    </div>
                </div>
            </Wp_card_sku>

        </div>
        <div v-else @click="buyGoods">
            <Wp_image v-if="skuInfo.imageInfo && skuInfo.imageInfo.imageList"
                      :url="skuInfo.imageInfo.imageList[0].url"
                      :img-gray="imgGray"
                      radius="10px 10px 0px 0"
            ></Wp_image>
            <div style="padding: 5px 10px">
                <div class="sku_title">
                    {{skuInfo.skuName}}<span v-if="skuInfo.skuName.length <=15" style="color: rgba(0,0,0,0)">{{skuInfo.skuName}}</span>
                </div>
                <div class="sku_tags" style="display: flex">

                    <div style="display: flex"
                         v-if="couponData && couponData.discount && skuInfo.priceInfo.lowestCouponPrice">
                        <JdCouponBar :couponData="couponData"></JdCouponBar>
                        <!--                    <van-tag color="red" plain round style="padding: 1px 6px">券 ¥ {{couponData.discount}}</van-tag>-->
                        <span style="margin-left: 5px">
                            <van-tag type="danger" style="padding: 2px 6px" v-if="skuInfo.owner==='g'">自营</van-tag>
                        </span>
                    </div>



                    <div v-else style="float:left;">
                        <span v-if="skuInfo.owner==='g'" style="margin-right: 5px">
                            <van-tag type="danger" style="padding: 2px 6px">自营</van-tag>
                        </span>
                        <span v-if="skuInfo.pinGouInfo && skuInfo.pinGouInfo.pingouPrice"
                              style="color:red;margin: 2px 5px 2px 0px;">
                                <Icon type="ios-contacts" size="16" style="margin-top: -2px"/>
                                {{skuInfo.pinGouInfo.pingouTmCount}}人拼
                        </span>
                        <span v-else-if="skuInfo.isHot===1">
                            <van-tag color="red" plain style="padding: 2px 6px">爆品</van-tag>
                        </span>

                        <span v-else>
                            <van-tag color="rgba(0,0,0,0)" style="padding: 1px 6px;">&nbsp;</van-tag>
                        </span>

                    </div>
                </div>

                <div>
                    <div v-if="skuInfo.priceInfo" style="color:red; font-size: 13px;">
                        <span v-if="couponData && couponData.discount && skuInfo.priceInfo.lowestCouponPrice">
                            <span>
                                ¥ <span style="font-size: 15px;">{{Number((skuInfo.priceInfo.lowestCouponPrice).toFixed(2))}}</span>
                            </span>
                            <span>&nbsp;</span>
                            <span style="font-size:9px;color:gray;text-decoration:line-through;">
                                ¥ <span style="font-size: 11px;">{{Number(skuInfo.priceInfo.lowestPrice.toFixed(2))}}</span>
                            </span>
                        </span>
                        <span v-else>
                            ¥ <span style="font-size: 15px;">{{Number(skuInfo.priceInfo.lowestPrice.toFixed(2))}}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <van-action-sheet
                title="推广详情"
                v-model="showLink"
                @close="sheetClosed"
                style="padding-bottom: 20px; min-height: 90%"
        >

            <div style="margin-bottom: 20px">
                <Alert type="warning" style="margin-left: 10px;margin-right: 10px">转发步骤:1.长按保存图片,2.点击复制文案。</Alert>
                <div style="text-align: center" v-if="imageList.length > 0">
                    <!--                    <img :src="skuInfo.imageInfo.imageList[0].url" width="50%"/>-->
                    <van-swipe @change="onSwipeChange">
                        <van-swipe-item v-for="(image, index) in imageList" :key="index">
                            <Wp_image :url="image.url" :width="'50'"></Wp_image>
                        </van-swipe-item>
                        <div class="custom-indicator" slot="indicator">
                            {{ currentIndex + 1 }}/{{imageList.length}}
                        </div>
                    </van-swipe>
                </div>
                <div>
                    <van-field
                            v-model="linkContent"
                            type="textarea"
                            :autosize="{maxHeight: 300, minHeight: 100}"
                    ></van-field>
                </div>
                <div style="text-align: center">
                    <van-sticky :offset-top="50" style="position: fixed;bottom: 25px;text-align: center;width: 100%">
                        <van-button v-if="newLink"
                                    type="info"
                                    size="small"
                                    style="width: 90%"
                                    v-clipboard:copy="linkContent.replace(new RegExp('<br/>','gm'),'\n')"
                                    v-clipboard:success="onCopySuccess"
                                    v-clipboard:error="onError"
                        >复制文案
                        </van-button>

                    </van-sticky>

                </div>

            </div>


            <van-button id="stamp_button" ref="stamp_button" type="danger" plain
                        style="width: auto; height: auto; z-index:1;border-radius: 3px;
                        padding-left: 5px; padding-right:5px; padding-top: 5px; padding-bottom: 5px;
                        display: none;position: absolute;right:10%;bottom:42%; background-color: #ffffff77;
                        transform: rotate(25deg)"
            >
                <van-button type="danger" plain hairline
                            style="width:100%; height: 100%;border-radius: 3px;background-color: #ffffff77; "
                ><h3>复制成功</h3>
                </van-button>
            </van-button>
        </van-action-sheet>

        <van-popup
                v-model="showDetail"
                position="bottom"
                :style="{ width: '100%', height: '100%'}"
        >
            <Wp_jd_sku_detail_page v-if="skuInfoData && showDetail"
                                   type="popup"
                                   :datas="skuInfoData"
                                   @clickToCloseDetail="clickToCloseDetail"
            ></Wp_jd_sku_detail_page>
        </van-popup>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Alert, Button, Col, Divider, Icon, Row, Tag} from 'iview';
    import JdCouponBar from "./JdCouponBar";
    import Wp_card_sku from "./Wp_card_sku";
    import Wp_image from "./Wp_image";
    import Wp_share_poster from "./Wp_share_poster";
    import {Dialog, Toast} from "vant";
    import Wp_jd_sku_detail_page from "../pages_childs/Wp_jd_sku_detail_page";

    Vue.component('Divider', Divider);
    Vue.component('Row', Row);
    Vue.component('i-col', Col);
    Vue.component('Tag', Tag);
    Vue.component('Icon', Icon);
    Vue.component('i-button', Button);
    Vue.component('Alert', Alert);


    export default {
        name: "JdSkuInfoCard_No_Pid",
        components: {Wp_jd_sku_detail_page, Wp_share_poster, Wp_image, Wp_card_sku, JdCouponBar},
        props: {
            skuInfo: {type: Object, default: null},
            // couponData: {type: Object, default: null},
            width: {type: String, default: '90%'},
            id_index: {type: Number, default: 0},
            imgGray: {type: Boolean, default: false},
            orientation: {type: String, default: 'horizontal'},
        },
        data() {
            return {
                couponData: {},
                //实际金额
                actual_cost: 0,
                //佣金金额
                commission: 0,
                //佣金比例
                commissionShare: 0,

                newLink: '',
                linkContent: '',
                showLink: false,

                imageList: [],
                //swipe当前的index
                currentIndex: 0,

                // img_url: "http://img14.360buyimg.com/ads/jfs/t1/100807/6/530/269231/5dafaaf4Ece749f19/aa19bf49d95a5135.jpg",
                img_url: "",

                has_show: false,
                share_img_url: "",
                show_share_pop: '',

                position_id: '',

                showDetail: false,
                skuInfoData: null,

                // upgrade_tip: "升级超级会员推广可赚￥" + this.commission,
            }
        },
        created() {
            this.$log("$common.gloabl_wx_openid = " + this.$common.gloabl_wx_openid)
            if (this.skuInfo) {
                this.findCoupon();
                //佣金比例，除以2，平分，0.9是订单返回数据中的finalRate最终比例
                this.commissionShare = this.skuInfo.commissionInfo.commissionShare * 0.9 * this.$common.commissionRate_pir;
                if (this.commissionShare.toString().indexOf(".") > 0) {
                    this.commissionShare = (this.commissionShare).toFixed(2);
                }

                if (this.couponData && this.couponData.discount && this.skuInfo.priceInfo.lowestCouponPrice) {
                    //如果包含优惠券，佣金金额=(最低金额-优惠券金额) * 佣金比例 / 2 / 100，取小数点后两位，（除以2是平分实际佣金）
                    this.commission = ((this.skuInfo.priceInfo.lowestCouponPrice) * (this.commissionShare / 100));
                } else {
                    // this.commission = (this.skuInfo.commissionInfo.commission / 2);
                    this.commission = this.skuInfo.priceInfo.lowestPrice * (this.commissionShare / 100);
                }
                //取两位小数
                this.commission = (this.commission).toFixed(2);

                // this.getImgUrl();
            }
        },

        mounted() {
            this.has_show = this.isCanShow();
            try {
                this.share_img_url = this.skuInfo.imageInfo.imageList[0].url
            } catch (e) {

            }
        },
        // computed: {
        //     /**
        //      * 动态旋转
        //      * @return {string}
        //      */
        //     iconstyle() {
        //         let arr = new Array();
        //         arr.push('transform:');
        //         arr.push('rotate(' + 30 + 'deg) ');
        //         return arr.join("");
        //
        //     }
        // },
        methods: {

            clickToUpgrade() {
                this.navigateToUpgrade();
            },

            /**
             * 打开小程序中的升级界面
             */
            navigateToUpgrade() {
                this.$common.navigateToMiniProgramPage("../wp_upgrade/wp_upgrade?");
            },

            clickToCloseDetail() {
                this.showDetail = false;
            },

            /**
             * 立即购买
             */
            buyGoods() {
                // let url = 'baiduboxapp://swan/v2G6Yj4yiYYWLCyesipgtUutyLaXNKzc/pages/wp_jd/wp_detail/wp_detail?skuId=' + this.skuInfo.skuId;
                // window.location.href = url;
                // return;
                if (this.$common.gloabl_wx_mini_login_status) {
                    if (this.$common.gloabl_wx_mini_login_status === "none") {
                        //如果登录状态为none，则需要弹出一键登录界面
                        this.navigateToLogin();
                    } else {
                        if (this.$common.gloabl_wx_mini_login_status === "normal") {
                            //如果是普通会员，并且有上级群主
                            if (this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.f_id) {
                                //使用上级群主的position_id进行购物
                                this.position_id = this.$common.gloabl_wx_mini_user_info.f_id;
                            } else {
                                //如果没有上级群主，则给他分配一个固定群主的position_id
                                this.position_id = "1924367099";
                            }
                        }

                        if (this.$common.gloabl_wx_mini_login_status === "super") {
                            //如果是超级会员，并且登录了群主平台
                            if (this.$common.getPid()) {
                                this.position_id = this.$common.getPid();
                            } else {
                                if (this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.channel_id) {
                                    //使用自己的群主id进行购物
                                    this.position_id = this.$common.gloabl_wx_mini_user_info.channel_id;
                                }
                            }
                        }

                        // if(this.$common.isBaidu_swan()){
                        //     let _skuInfo = this.skuInfo;
                        //     //添加一个时间戳，已保证如果是同一个商品，在详情页面也能通过watch监听到
                        //     _skuInfo.time_tag = new Date().getTime();
                        //
                        //     this.skuInfoData = _skuInfo;
                        //
                        //     this.showDetail = true;
                        // }else{
                        //     //跳转小程序
                        //     let _skuId = this.skuInfo.skuId;
                        //
                        //     if (_skuId) {
                        //         this.navigateToDetail(JSON.stringify(_skuId));
                        //     }
                        // }

                        //跳转小程序
                        let _skuId = this.skuInfo.skuId;
                        if (this.$common.isWx_mini()) {
                            if (_skuId) {
                                this.navigateToDetail(JSON.stringify(_skuId));
                            }
                        } else {
                            Dialog.alert({
                                title: '运行环境异常',
                                message: '检测到您当前的运行环境不是在微信小程序中，当前功能无法使用，请确认是在微信小程序中运行'
                            })
                        }


                        // if (_skuId) {
                        //     // let url = 'baiduboxapp://swan/v2G6Yj4yiYYWLCyesipgtUutyLaXNKzc/pages/wp_jd/wp_detail/wp_detail?skuId=_skuId';
                        //     // window.location.href = url;
                        //
                        //     // let _data = this.getUrlParams(_skuId);
                        //     //
                        //     this.$getUnionLink(_data, response => {
                        //         let code = response.code;
                        //         // let message = response.message;
                        //         if (code === 200) {
                        //             let shortURL = response.data.shortURL;
                        //             this.newLink = shortURL;
                        //
                        //             // that.$get(that.newLink);
                        //
                        //             location.href = this.newLink;
                        //
                        //             // this.skuInfo.jd_url = shortURL;
                        //             // this.navigateToDetail(JSON.stringify(this.skuInfo));
                        //
                        //         }
                        //     })
                        // }
                    }
                } else {
                    this.position_id = "1924367099";
                    let _skuId = this.skuInfo.skuId;

                    if (_skuId) {
                        this.navigateToDetail(JSON.stringify(_skuId));
                    }
                }

            },

            /**
             * 打开小程序的登录界面
             */
            navigateToLogin() {
                this.$common.navigateToMiniProgramPage("../wp_user_login/wp_user_login?event=login");
            },

            /**
             * 打开小程序中的详情界面
             */
            navigateToDetail(sku_str) {
                this.$common.navigateToMiniProgramPage("../wp_detail/wp_detail?", "skuId", sku_str);
            },


            /**
             * 加入选品清单
             */
            addInSelectList() {
                // this.$emit("addInSelectList", this.skuInfo.skuId);
                this.$emit("addInSelectList", this.skuInfo, this.skuInfo.skuId);
            },

            /**
             * 商品是否可以显示，如果有优惠券，则原价-优惠券的价格要大于0，否则不显示
             */
            isCanShow() {
                if (this.skuInfo) {
                    if (this.skuInfo.couponInfo.couponList && this.skuInfo.couponInfo.couponList.length > 0) {
                        if (typeof (this.skuInfo.priceInfo.lowestPrice) == 'undefined') {
                            return true
                        }
                        if (this.skuInfo.priceInfo.lowestPrice - this.couponData.discount > 0) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            },


            /**
             * swipe滚动监听
             */
            onSwipeChange(index) {
                this.currentIndex = index;
            },
            /**
             * 查找优惠券
             */
            findCoupon() {
                let couponList = this.skuInfo.couponInfo.couponList;
                let _couponData = this.$common.autoFindCoupon2(couponList);
                if (_couponData) {
                    this.couponData = _couponData;
                }
            },

            // onChange(value) {
            //     this.m_pid_list = value;
            //     if (this.m_pid_list) {
            //         this.linkList = [];
            //         for (let i in this.m_pid_list) {
            //             let _pid = this.m_pid_list[i];
            //             let _pidInfo = this.$common.splitPid(_pid);
            //             let _appInfo = this.$common.getAppKeyInfo(_pidInfo.media_id);
            //             let _data = {
            //                 id: _pid,
            //                 name: _pidInfo.channel_name,
            //                 pidInfo: _pidInfo,
            //                 appInfo: _appInfo,
            //                 newLink: '',
            //             };
            //             this.linkList.push(_data);
            //         }
            //     }
            //     // this.$emit('change',value);
            // },

            makeLinks(fn) {
                let _skuId = this.skuInfo.skuId;
                if (_skuId) {
                    let _materialId = 'https://wqitem.jd.com/item/view?sku=' + _skuId;
                    let _couponUrl = '';
                    if (this.couponData && this.couponData.discount && typeof (this.couponData.discount) !== 'undefined' && this.skuInfo.priceInfo.lowestCouponPrice) {
                        _couponUrl = this.couponData.link;
                    }
                    let _positionId = this.$common.getPid();
                    // let _positionId = '1825325610';
                    let _data = {
                        app_key: this.$common.getAppKeyInfo('70637').app_key,
                        app_secret: this.$common.getAppKeyInfo('70637').app_secret,
                        materialId: _materialId,
                        subUnionId: '',
                        positionId: _positionId, //推广位ID
                        // pid: _pid,
                        couponUrl: _couponUrl,
                        chainType: 2,
                    };

                    this.$getUnionLink(_data, response => {
                        let code = response.code;
                        // let message = response.message;
                        if (code === 200) {
                            let shortURL = response.data.shortURL;
                            this.newLink = shortURL;
                            if (fn && typeof fn === 'function') {
                                fn(shortURL)
                            } else {
                                this.getLinkContent(shortURL);
                                //使用setTimeout避免ActionSheet使用了Swipe弹出时，会先跟着半透明蒙板变暗，然后再完全展现
                                setTimeout(() => {
                                    this.imageList = this.skuInfo.imageInfo.imageList;
                                });
                                //打开复制文案弹窗
                                this.showLink = true;
                            }

                        } else {
                            // Dialog.alert({
                            //     message: "添加失败，商品活动已过期"
                            // });
                            Toast({
                                duration: 1000,
                                message: "添加失败\n商品活动已过期"
                            })
                        }
                        // else if (code === 2001917) {
                        //     this.$dialog.alert({
                        //         message: response.message
                        //     });
                        // }
                    })
                }

            },

            /**
             * 获取请求url所需的参数，json格式
             */
            getUrlParams(skuId) {
                let mediaId = this.$common.mediaId_70637;
                let _materialId = 'https://wqitem.jd.com/item/view?sku=' + skuId;
                let _couponUrl = '';
                if (this.couponData && this.couponData.discount && typeof (this.couponData.discount) !== 'undefined' && this.skuInfo.priceInfo.lowestCouponPrice) {
                    _couponUrl = this.couponData.link;
                }

                let _positionId = this.$common.getPid();

                if (this.position_id || this.$common.gloabl_wx_openid) {
                    _positionId = this.position_id;
                }

                // let _positionId = '1825325610';

                let _data = {
                    app_key: this.$common.getAppKeyInfo(mediaId).app_key,
                    app_secret: this.$common.getAppKeyInfo(mediaId).app_secret,
                    materialId: _materialId,
                    subUnionId: '',
                    positionId: _positionId, //推广位ID
                    // pid: _pid,
                    couponUrl: _couponUrl,
                    chainType: 2,
                };
                return _data;
            },

            /**
             * 显示"复制成功"的图章
             */
            showStamp() {
                // let stampButton = document.getElementById('stamp_button');
                // stampButton.style.display = 'block';
                //展示"复制成功"图章
                this.$refs.stamp_button.style.display = 'block';
            },
            /**
             * sheet上拉模板关闭时回调
             */
            sheetClosed() {
                // let stampButton = document.getElementById('stamp_button');
                // stampButton.style.display = 'none';
                //删除"复制成功"图章
                this.$refs.stamp_button.style.display = 'none';
                //swipe所要加载的图片集合重置
                this.imageList = [];
                //swipe的indicator角标重置
                this.currentIndex = 0;
            },
            onCopySuccess() {
                this.showStamp();
                setTimeout(() => {
                    // this.showLink = false;
                    // this.$toast.success({
                    //     message: '复制成功',
                    //     duration: 1000
                    // });
                    this.$notify({
                        message: '\n复制成功\n ',
                        duration: 2000,
                        background: '#1989fa'
                    });

                }, 500);

                // window.navigator.clipboard.readText().then(clipText=>{
                // })
            },
            onError() {
                // this.$toast.error({
                //     message: '复制失败',
                //     duration: 1000
                // });
                setTimeout(() => {
                    this.$notify({
                        message: '\n复制失败\n ',
                        duration: 2000,
                    });
                }, 500);
            },
            getLinkContent(newLink) {
                let content = '';
                content += '【京东】' + this.skuInfo.skuName + '\n';
                content += '评论数: ' + this.skuInfo.comments + '  ';
                content += '好评率: ' + this.skuInfo.goodCommentsShare + '%' + '\n';
                content += '--------------------------' + '\n';

                if (this.couponData && this.couponData.discount && typeof (this.couponData.discount) !== 'undefined' && this.skuInfo.priceInfo.lowestCouponPrice) {
                    content += '京东价: ' + this.skuInfo.priceInfo.lowestPrice.toFixed(2) + '元(券' + (this.couponData.discount).toFixed(0) + '元)' + '\n';

                    content += '内购价: ' + (this.skuInfo.priceInfo.lowestCouponPrice).toFixed(2) + '元' + '\n';
                } else {
                    content += '京东价: ' + this.skuInfo.priceInfo.lowestPrice.toFixed(2) + '元' + '\n';
                }
                content += '抢购: ' + newLink + '\n';
                content += '--------------------------' + '\n';
                let second_host_url = this.$store.state.username + '.wapg.cn';
                content += '更多优惠: ' + second_host_url.toLowerCase();
                this.linkContent = content;
            },
            showSharePop() {
                let that = this;
                this.makeLinks(function (shortUrl) {
                    let timestamp = "_" + Date.parse(new Date());
                    that.show_share_pop = timestamp;
                })
            },
            getImageIndex(index) {
                if (!index) {
                    index = 0;
                }
                this.share_img_url = this.skuInfo.imageInfo.imageList[index].url

            }
        }
    }
</script>

<style scoped>
    .sku_info {
        font-size: 12px;
        text-align: left;
        margin: 5px;
    }

    .sku_title {
        /*height: 45px;*/
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        /*解决英文数字不换行或长度超出问题*/
        word-break: break-all;
    }

    .sku_price {
        font-size: 12px;
    }

    .result_price {
        font-size: 18px;
    }

    .sku_old_price {
        font-size: 10px;
        text-align: center;
        padding-top: 5px;
    }

    .sku_month {
        font-size: 12px;
        text-align: left;
    }

    .sku_tags {
        display: inline-block;
        margin-top: 5px;
    }

    /*.van-popup--bottom {*/
    /*    border-radius: 12px 12px 0 0;*/
    /*}*/

    .custom-indicator {
        position: absolute;
        right: 5px;
        bottom: 5px;
        padding: 1px 7px;
        color: #fff;
        font-size: 12px;
        background: rgba(0, 0, 0, 0.3);
    }

    .sku_card_bottom_btn {
        margin-right: 5px;
        padding-left: 5px;
        padding-right: 5px
    }

</style>